import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { ExampleView } from '../../views';

export const exerciseData32Testimony: ExerciseData = {
    ExerciseView: Module3Exercise2Testimony,
    dataKeys: [],
    questions: [],
};

function Module3Exercise2Testimony({ exercise }: ExerciseViewProps) {
    return (
        <ExampleView
            exercise={exercise}
            body={[
                'Jeg føler mig ofte overvældet af alt det, jeg skal nå i min hverdag. Jeg bor til leje og er allerede flyttet 3 gange de sidste to år, og det presser mig virkelig ikke at have en fast base. Samtidig prøver jeg at være en god veninde, holde mig sund og finde tid til min familie. Det føles som om, jeg konstant løber fra det ene til det andet, og jeg har svært ved at finde tid til bare at trække vejret.',
                'Stressen begynder at påvirke mig – jeg har svært ved at koncentrere mig, og jeg føler mig træt hele tiden. Oven i det taler jeg ofte grimt til mig selv. Jeg siger ting som: "Hvorfor kan du ikke bare tage dig sammen?" eller "Alle andre klarer det jo, hvorfor kan du ikke?" Det gør det hele endnu sværere, for i stedet for at støtte mig selv, ender jeg med at slå mig selv i hovedet. Jeg vil så gerne klare det hele, men jeg er begyndt at spørge mig selv, om det overhovedet er muligt.',
            ]}
        />
    );
}
